import { invalidEmailErrorMap } from './errorDictionary';
import { isValidEmail } from '../../utils/fieldValidators';
import useValidators from './useValidators';
function useValidEmail() {
    const errorMessageMap = [invalidEmailErrorMap];
    const validators = [isValidEmail];
    return useValidators(errorMessageMap, validators);
}
export default useValidEmail;
